import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  FormHelperText,
} from "@mui/material";

const SelectInput = (props) => {
  return (
    <>
      <FormControl fullWidth>
        <InputLabel
          className="floatingLabelFocusStyle "
          sx={{
            display: "flex",
            width: "100%",
          }}
          id="demo-simple-select-label"
        >
          {props.label}
        </InputLabel>
        <Select
          sx={{
            display: "flex",
            width: "100%",
          }}
          labelId="demo-simple-select-label"
          label={props.label}
          value={props.value}
          name={props.name}
          onChange={(e)=>props.handleInputChange(e)}
        >
          {props.List.map((ele) => (
            <MenuItem key={ele.id} value={ele.value}>
              {ele.name}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>{props.helperText}</FormHelperText>
      </FormControl>
    </>
  );
};

export default SelectInput;
